import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaHeart,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-4 bg-dark text-white mt-3">
      <div className="container">
        {/* Footer Main Section */}
        <div className="row align-items-center text-center text-md-start">
          {/* Logo Section */}
          <div className="col-12 col-md-4 mb-3 mb-md-0">
            <Link to="/" className="text-decoration-none">
              <h5 className="fw-bold text-white">Shine International School</h5>
            </Link>
            <p className="trusted-para mt-3">
              Your trusted partner in excellence.
            </p>
          </div>

          {/* Social Media Section */}
          <div className="col-12 col-md-4 mb-3 mb-md-0 text-center">
            <h5 className="fw-bold">Follow Us</h5>
            <div className="d-flex justify-content-center gap-3 mt-2">
              <a
                href="https://www.facebook.com/p/Shine-International-School-Jamudag-Ranchi-100083316153715/"
                target="_blank"
                className="text-white"
              >
                <FaFacebook size={28} />
              </a>
              <a href="#" className="text-white">
                <FaTwitter size={28} />
              </a>
              <a href="#" className="text-white">
                <FaInstagram size={28} />
              </a>
              <a href="#" className="text-white">
                <FaLinkedin size={28} />
              </a>
            </div>
          </div>

          {/* Copyright Section */}
          <div className="col-12 col-md-4 text-md-end">
            <p className="text-white">
              &copy; {new Date().getFullYear()} Shine International School.{" "}
              <br />
              All rights reserved.
            </p>
            <p>
              Made with <FaHeart style={{ color: "red" }} /> by{" "}
              <a
                className="badge rounded-pill bg-white text-dark bg-gradient"
                style={{ cursor: "pointer" }}
                href="/devsphire"
              >
                DevSphire
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
